import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import utils from 'utils';
import AdChoices from 'components/AdChoices';

/**
 * A public init method must exist to be called from uiManager
 * @param {Object} store The redux store for the site
 * @param {HTMLElement} domEl The dom element related to this module
 */
export default {
  init(store) {
    const $adChoices = document.getElementById('adChoices');
    const showAdChoices = utils.config.getShowAdChoices();
    const hasSeenAdchoices = utils.cookie.get('adchoices');

    /**
     * Only render this component if `showAdChoices` is set to `true`,
     * of the element exists and if user hasn't seen the banner yet.
     */
    if (!$adChoices || !showAdChoices || hasSeenAdchoices) {
      return;
    }
    const root = createRoot($adChoices);
    root.render(
      <Provider store={store}>
        <AdChoices />
      </Provider>
    );
  },
};
